// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as VGSHelpers$OrcaPaymentPage from "../Utilities/VGSHelpers.bs.js";
import * as CommonHooks$OrcaPaymentPage from "../Hooks/CommonHooks.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as VGSConstants$OrcaPaymentPage from "../Utilities/VGSConstants.bs.js";
import * as ErrorComponent$OrcaPaymentPage from "../Components/ErrorComponent.bs.js";
import * as VGSInputComponent$OrcaPaymentPage from "../Components/VGSInputComponent.bs.js";

var vgsScriptIntegrity = "sha384-ddxU1XAc77oB4EIpKOgJQ3FN2a6STYPK0JipRqg1x/eW+n5MFn1XbbZa7+KRjkqc";

function VGSVault(props) {
  var __cvcOnly = props.cvcOnly;
  var cvcOnly = __cvcOnly !== undefined ? __cvcOnly : false;
  var vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var match$1 = match.config.appearance;
  var innerLayout = match$1.innerLayout;
  var match$2;
  if (typeof vaultCredentials !== "object" || vaultCredentials.TAG === "HyperswitchVault") {
    match$2 = [
      "",
      ""
    ];
  } else {
    var creds = vaultCredentials._0;
    match$2 = [
      creds.vaultId,
      creds.environment
    ];
  }
  var environment = match$2[1];
  var vaultId = match$2[0];
  var match$3 = React.useState(function () {
        
      });
  var setIsCardFocused = match$3[1];
  var match$4 = React.useState(function () {
        
      });
  var setIsCVCFocused = match$4[1];
  var isCVCFocused = match$4[0];
  var match$5 = React.useState(function () {
        
      });
  var setIsExpiryFocused = match$5[1];
  var match$6 = React.useState(function () {
        
      });
  var setForm = match$6[1];
  var form = match$6[0];
  var match$7 = React.useState(function () {
        
      });
  var setCardField = match$7[1];
  var cardField = match$7[0];
  var match$8 = React.useState(function () {
        
      });
  var setExpiryField = match$8[1];
  var expiryField = match$8[0];
  var match$9 = React.useState(function () {
        
      });
  var setCVCField = match$9[1];
  var cvcField = match$9[0];
  var match$10 = React.useState(function () {
        return "";
      });
  var setVgsCardError = match$10[1];
  var vgsCardError = match$10[0];
  var match$11 = React.useState(function () {
        return "";
      });
  var setVgsExpiryError = match$11[1];
  var vgsExpiryError = match$11[0];
  var match$12 = React.useState(function () {
        return "";
      });
  var setVgsCVCError = match$12[1];
  var vgsCVCError = match$12[0];
  var vgsScriptStatus = CommonHooks$OrcaPaymentPage.useScript(VGSConstants$OrcaPaymentPage.vgsScriptURL, undefined, vgsScriptIntegrity, "anonymous");
  var vaultInitializedRef = React.useRef(false);
  var formStateRef = React.useRef({});
  React.useEffect((function () {
          VGSHelpers$OrcaPaymentPage.handleVGSField(cardField, setIsCardFocused, setVgsCardError);
        }), [cardField]);
  React.useEffect((function () {
          VGSHelpers$OrcaPaymentPage.handleVGSField(expiryField, setIsExpiryFocused, setVgsExpiryError);
        }), [expiryField]);
  React.useEffect((function () {
          VGSHelpers$OrcaPaymentPage.handleVGSField(cvcField, setIsCVCFocused, setVgsCVCError);
        }), [cvcField]);
  var initializeVGSFields = function (vault) {
    if (!cvcOnly) {
      setCardField(function (param) {
            return vault.field("#vgs-cc-number", VGSConstants$OrcaPaymentPage.cardNumberOptions);
          });
      setExpiryField(function (param) {
            return vault.field("#vgs-cc-expiry", VGSConstants$OrcaPaymentPage.cardExpiryOptions(localeString.expiryPlaceholder));
          });
    }
    setCVCField(function (param) {
          return vault.field("#vgs-cc-cvc", cvcOnly ? VGSConstants$OrcaPaymentPage.savedCardCvcOptions : VGSConstants$OrcaPaymentPage.cardCvcOptions);
        });
    setForm(function (param) {
          return vault;
        });
  };
  var handleVGSErrors = function (vgsState) {
    var dict = Utils$OrcaPaymentPage.getDictFromJson(vgsState);
    formStateRef.current = dict;
    var setIfPresent = function (setError, errStr) {
      if (errStr !== "") {
        return setError(function (param) {
                    return errStr;
                  });
      }
      
    };
    setIfPresent(setVgsCardError, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_number", undefined, localeString));
    setIfPresent(setVgsExpiryError, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_exp", undefined, localeString));
    setIfPresent(setVgsCVCError, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_cvc", undefined, localeString));
  };
  React.useEffect((function () {
          switch (vgsScriptStatus) {
            case "error" :
                Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                        "vgsScriptLoadFailed",
                        true
                      ]]);
                break;
            case "ready" :
                if (vaultId !== "" && environment !== "" && !vaultInitializedRef.current) {
                  vaultInitializedRef.current = true;
                  var vault = VGSCollect.create(vaultId, environment, handleVGSErrors);
                  initializeVGSFields(vault);
                }
                break;
            default:
              
          }
        }), [
        vaultId,
        environment,
        vgsScriptStatus
      ]);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirmDict = Utils$OrcaPaymentPage.getDictFromJson(json);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(confirmDict);
          var isOuterValid = Utils$OrcaPaymentPage.getBool(confirmDict, "isOuterValid", true);
          if (!confirm.doSubmit) {
            return ;
          }
          if (form !== undefined) {
            var stateDict = formStateRef.current;
            if (cvcOnly) {
              var cvcErr = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_cvc", true, localeString);
              setVgsCVCError(function (param) {
                    return cvcErr;
                  });
              if (!(cvcErr === "" && isOuterValid)) {
                if (cvcErr !== "") {
                  return VGSHelpers$OrcaPaymentPage.submitUserError(VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_cvc") ? localeString.enterFieldsText : localeString.enterValidDetailsText);
                } else {
                  return ;
                }
              }
              var emptyPayload = {};
              var onSuccess = function (param, data) {
                var cvcToken = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(data), "card_cvc", "");
                Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                      [
                        "savedCardCvcTokenEvent",
                        true
                      ],
                      [
                        "cvcToken",
                        cvcToken
                      ]
                    ]);
              };
              var onError = function (param) {
                Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
              };
              return form.submit("/post", emptyPayload, onSuccess, onError);
            }
            var cardErr = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_number", true, localeString);
            var expiryErr = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_exp", true, localeString);
            var cvcErr$1 = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_cvc", true, localeString);
            setVgsCardError(function (param) {
                  return cardErr;
                });
            setVgsExpiryError(function (param) {
                  return expiryErr;
                });
            setVgsCVCError(function (param) {
                  return cvcErr$1;
                });
            var cardFieldsValid = cardErr === "" && expiryErr === "" && cvcErr$1 === "";
            if (cardFieldsValid && isOuterValid) {
              var emptyPayload$1 = {};
              var onSuccess$1 = function (param, data) {
                var match = VGSHelpers$OrcaPaymentPage.getTokenizedData(data);
                Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                      [
                        "vgsTokenEvent",
                        true
                      ],
                      [
                        "vgsCardData",
                        Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                              [
                                "cardNumber",
                                match[0]
                              ],
                              [
                                "month",
                                match[1]
                              ],
                              [
                                "year",
                                match[2]
                              ],
                              [
                                "cvcNumber",
                                match[3]
                              ]
                            ])
                      ]
                    ]);
              };
              var onError$1 = function (param) {
                Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
              };
              return form.submit("/post", emptyPayload$1, onSuccess$1, onError$1);
            }
            if (cardFieldsValid) {
              return ;
            }
            var anyEmpty = VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_number") || VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_exp") || VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_cvc");
            return VGSHelpers$OrcaPaymentPage.submitUserError(anyEmpty ? localeString.enterFieldsText : localeString.enterValidDetailsText);
          }
          console.error("VGS Vault not initialized for submission");
        }), [
        form,
        localeString,
        cvcOnly
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement("div", {
              className: "animate-slowShow"
            }, React.createElement("div", {
                  className: "flex flex-col",
                  style: {
                    gridGap: themeObj.spacingGridColumn
                  }
                }, cvcOnly ? React.createElement("div", {
                        className: "flex flex-col w-full",
                        style: {
                          gridGap: themeObj.spacingGridColumn
                        }
                      }, React.createElement(VGSInputComponent$OrcaPaymentPage.make, {
                            fieldName: "",
                            id: "vgs-cc-cvc",
                            isFocused: Core__Option.getOr(isCVCFocused, false),
                            errorStr: vgsCVCError,
                            compact: true,
                            height: "1.8rem"
                          }), React.createElement(ErrorComponent$OrcaPaymentPage.make, {
                            cvcError: vgsCVCError
                          })) : React.createElement("div", {
                        className: "flex flex-col w-full",
                        style: {
                          gridGap: themeObj.spacingGridColumn
                        }
                      }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                            condition: innerLayout === "Compressed",
                            children: React.createElement("div", {
                                  style: {
                                    fontSize: themeObj.fontSizeLg,
                                    marginBottom: "5px",
                                    opacity: "0.6"
                                  }
                                }, localeString.cardHeader)
                          }), React.createElement(VGSInputComponent$OrcaPaymentPage.make, {
                            fieldName: localeString.cardNumberLabel,
                            id: "vgs-cc-number",
                            isFocused: Core__Option.getOr(match$3[0], false),
                            errorStr: vgsCardError
                          }), React.createElement("div", {
                            className: "flex flex-row w-full place-content-between",
                            style: {
                              gridColumnGap: innerLayout === "Spaced" ? themeObj.spacingGridRow : ""
                            }
                          }, React.createElement("div", {
                                className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
                              }, React.createElement(VGSInputComponent$OrcaPaymentPage.make, {
                                    fieldName: localeString.validThruText,
                                    id: "vgs-cc-expiry",
                                    isFocused: Core__Option.getOr(match$5[0], false),
                                    errorStr: vgsExpiryError
                                  })), React.createElement("div", {
                                className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
                              }, React.createElement(VGSInputComponent$OrcaPaymentPage.make, {
                                    fieldName: localeString.cvcTextLabel,
                                    id: "vgs-cc-cvc",
                                    isFocused: Core__Option.getOr(isCVCFocused, false),
                                    errorStr: vgsCVCError
                                  }))), React.createElement(ErrorComponent$OrcaPaymentPage.make, {
                            cardError: vgsCardError,
                            expiryError: vgsExpiryError,
                            cvcError: vgsCVCError
                          }))));
}

var make = VGSVault;

var $$default = VGSVault;

export {
  vgsScriptIntegrity ,
  make ,
  $$default as default,
}
/* jotai Not a pure module */
